module.exports = __webpack_public_path__ + "img/spcr.c62a14aa.png";